import { useState } from "react";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileText, Download, ExternalLink, Shield, Volume2, Coffee, Building2, DoorOpen, Radio, AlertTriangle, Lock, Car, Users, Cpu, Video, Layout, Clock, Mic, Smartphone, ChevronDown, ChevronUp } from "lucide-react";

// All BioCV modules with their datasheets - PUBLIC PAGE
const BIOCV_MODULES = [
  {
    id: 'access_control',
    name: 'ZKBioCV Access Control Module',
    description: 'Door access management with multiple credential types including Face, Palm, Card, PIN, QR Code, and Bluetooth',
    icon: Shield,
    color: 'bg-blue-500',
    datasheetUrl: 'https://customer-assets.emergentagent.com/job_security-modules-1/artifacts/6btmji0d_ZKBioCV-Access-Control-Module.pdf'
  },
  {
    id: 'audio_broadcast',
    name: 'ZKBioCV Audio Broadcast Module',
    description: 'Centralized audio announcement and broadcast system for emergency notifications and general communications',
    icon: Volume2,
    color: 'bg-pink-500',
    datasheetUrl: 'https://customer-assets.emergentagent.com/job_security-modules-1/artifacts/trdpkkg2_ZKBioCV-Audio-Broadcast-Module%20%281%29.pdf'
  },
  {
    id: 'consumption',
    name: 'ZKBioCV Consumption Module',
    description: 'Cafeteria and consumption management with meal tracking and payment integration',
    icon: Coffee,
    color: 'bg-amber-500',
    datasheetUrl: 'https://customer-assets.emergentagent.com/job_security-modules-1/artifacts/8pa8gznu_ZKBioCV-Consumption-Module.pdf'
  },
  {
    id: 'elevator_control',
    name: 'ZKBioCV Elevator Control Module',
    description: 'Floor-level access control for elevators integrated with access credentials',
    icon: Building2,
    color: 'bg-indigo-500',
    datasheetUrl: 'https://customer-assets.emergentagent.com/job_security-modules-1/artifacts/zrii45yw_ZKBioCV-Elevator-Control-Module.pdf'
  },
  {
    id: 'entrance_control',
    name: 'ZKBioCV Entrance Control Module',
    description: 'Turnstile and entrance barrier integration for controlled pedestrian access',
    icon: DoorOpen,
    color: 'bg-cyan-500',
    datasheetUrl: 'https://customer-assets.emergentagent.com/job_security-modules-1/artifacts/v9rcw91t_ZKBioCV-Entrance-Control-Module.pdf'
  },
  {
    id: 'guard_patrol',
    name: 'ZKBioCV Guard Patrol Module',
    description: 'Security patrol route management and checkpoint monitoring',
    icon: Radio,
    color: 'bg-orange-500',
    datasheetUrl: 'https://customer-assets.emergentagent.com/job_security-modules-1/artifacts/w5a3oag6_ZKBioCV-Guard-Patrol-Module.pdf'
  },
  {
    id: 'intrusion_alarm',
    name: 'ZKBioCV Intrusion Alarm',
    description: 'Integrated intrusion detection and alarm management system',
    icon: AlertTriangle,
    color: 'bg-red-500',
    datasheetUrl: 'https://customer-assets.emergentagent.com/job_security-modules-1/artifacts/z57mlb2h_ZKBioCV-Intrusion-Alarm.pdf'
  },
  {
    id: 'locker_management',
    name: 'ZKBioCV Locker Management Module',
    description: 'Smart locker allocation and access control for secure storage',
    icon: Lock,
    color: 'bg-slate-500',
    datasheetUrl: 'https://customer-assets.emergentagent.com/job_security-modules-1/artifacts/rw2undqs_ZKBioCV-Locker-Mgmt-Module.pdf'
  },
  {
    id: 'parking',
    name: 'ZKBioCV Parking Module',
    description: 'Vehicle access control, parking space management, and ANPR integration',
    icon: Car,
    color: 'bg-green-500',
    datasheetUrl: 'https://customer-assets.emergentagent.com/job_security-modules-1/artifacts/byuxcsj7_ZKBioCV-Parking-Module.pdf'
  },
  {
    id: 'personnel',
    name: 'ZKBioCV Personnel Module',
    description: 'Employee database management, organizational structure, and HR integration',
    icon: Users,
    color: 'bg-violet-500',
    datasheetUrl: 'https://customer-assets.emergentagent.com/job_security-modules-1/artifacts/p6a55ory_ZKBioCV-Personnel-Module.pdf'
  },
  {
    id: 'scene_centre',
    name: 'ZKBioCV Scene Centre Module',
    description: 'Centralized monitoring dashboard with real-time event visualization',
    icon: Cpu,
    color: 'bg-gray-600',
    datasheetUrl: 'https://customer-assets.emergentagent.com/job_security-modules-1/artifacts/wqpjulby_ZKBioCV-Scene-Centre-Module.pdf'
  },
  {
    id: 'smart_video',
    name: 'ZKBioCV Smart Video Module',
    description: 'Video surveillance integration with intelligent analytics and recording',
    icon: Video,
    color: 'bg-rose-500',
    datasheetUrl: 'https://customer-assets.emergentagent.com/job_security-modules-1/artifacts/vt045a15_ZKBioCV-Smart-Video-Module.pdf'
  },
  {
    id: 'space_management',
    name: 'ZKBioCV Space Management Module',
    description: 'Room booking, desk allocation, and workspace utilization tracking',
    icon: Layout,
    color: 'bg-sky-500',
    datasheetUrl: 'https://customer-assets.emergentagent.com/job_security-modules-1/artifacts/189rm711_ZKBioCV-Space-Mgmt-Module.pdf'
  },
  {
    id: 'time_attendance',
    name: 'ZKBioCV Time and Attendance',
    description: 'Employee time tracking with clocking points, attendance reports, and workforce management',
    icon: Clock,
    color: 'bg-teal-500',
    datasheetUrl: 'https://customer-assets.emergentagent.com/job_security-modules-1/artifacts/ym6ufan9_ZKBioCV-Time-Attendance-Module.pdf'
  },
  {
    id: 'video_intercom',
    name: 'ZKBioCV Video Intercom Module',
    description: 'Video door phone and intercom system integration for visitor verification',
    icon: Mic,
    color: 'bg-fuchsia-500',
    datasheetUrl: 'https://customer-assets.emergentagent.com/job_security-modules-1/artifacts/gdzb39rj_ZKBioCV-Video-Intercom-Module.pdf'
  },
  {
    id: 'visitor_management',
    name: 'ZKBioCV Visitor Management Module',
    description: 'Cloud-based visitor registration, check-in/out, and unmanned reception with FaceKiosk',
    icon: Users,
    color: 'bg-purple-500',
    datasheetUrl: 'https://customer-assets.emergentagent.com/job_security-modules-1/artifacts/szw6yh5t_ZKBioCV-Visitor-Management-Module.pdf'
  },
  {
    id: 'zexus_mobile',
    name: 'ZKBioCV Zexus Mobile App',
    description: 'Mobile application for remote access, notifications, and system management',
    icon: Smartphone,
    color: 'bg-emerald-500',
    datasheetUrl: 'https://customer-assets.emergentagent.com/job_security-modules-1/artifacts/2l7wynn6_ZKBioCV-Zexus-Mobile-App.pdf'
  }
];

const PublicDatasheets = () => {
  const [expandedModule, setExpandedModule] = useState(null);
  
  const modulesWithDatasheets = BIOCV_MODULES.filter(m => m.datasheetUrl);
  const modulesWithoutDatasheets = BIOCV_MODULES.filter(m => !m.datasheetUrl);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900">
      {/* Header */}
      <div className="bg-white/5 backdrop-blur-sm border-b border-white/10">
        <div className="max-w-6xl mx-auto px-4 py-6">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-4">
              <img src="/zkteco-logo.png" alt="ZKTeco" className="h-12 w-auto" />
              <div>
                <h1 className="text-2xl font-bold text-white">Bio CVSecurity</h1>
                <p className="text-sm text-slate-400">Enterprise Security Management Platform</p>
              </div>
            </div>
            <a 
              href="/login" 
              className="px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white text-sm font-medium rounded-lg transition-colors"
            >
              Login to Configure
            </a>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-6xl mx-auto px-4 py-12">
        {/* Hero Section */}
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-white mb-4">
            Product Datasheets
          </h2>
          <p className="text-lg text-slate-300 max-w-2xl mx-auto">
            Download detailed specifications and features for all Bio CVSecurity modules. 
            Click on any module below to view or download its datasheet.
          </p>
        </div>

        {/* Available Datasheets */}
        <div className="mb-12">
          <h3 className="text-xl font-semibold text-white mb-6 flex items-center gap-2">
            <FileText className="h-5 w-5 text-green-400" />
            Available Datasheets ({modulesWithDatasheets.length})
          </h3>
          
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            {modulesWithDatasheets.map((module) => {
              const ModuleIcon = module.icon;
              
              return (
                <a
                  key={module.id}
                  href={module.datasheetUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="group"
                >
                  <Card className="bg-white/10 border-white/20 hover:bg-white/15 hover:border-green-500/50 transition-all duration-300 h-full">
                    <CardContent className="p-5">
                      <div className="flex items-start gap-4">
                        <div className={`w-12 h-12 rounded-xl ${module.color} flex items-center justify-center flex-shrink-0 group-hover:scale-110 transition-transform`}>
                          <ModuleIcon className="h-6 w-6 text-white" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <h4 className="font-semibold text-white text-sm mb-1 group-hover:text-green-400 transition-colors">
                            {module.name}
                          </h4>
                          <p className="text-xs text-slate-400 line-clamp-2 mb-3">
                            {module.description}
                          </p>
                          <div className="flex items-center gap-1 text-green-400 text-xs font-medium">
                            <Download className="h-3 w-3" />
                            Download PDF
                            <ExternalLink className="h-3 w-3 ml-1" />
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                </a>
              );
            })}
          </div>
        </div>

        {/* Coming Soon */}
        <div>
          <button 
            onClick={() => setExpandedModule(expandedModule === 'coming' ? null : 'coming')}
            className="w-full text-left"
          >
            <h3 className="text-xl font-semibold text-white mb-6 flex items-center gap-2">
              <Clock className="h-5 w-5 text-slate-400" />
              Coming Soon ({modulesWithoutDatasheets.length})
              {expandedModule === 'coming' ? (
                <ChevronUp className="h-5 w-5 text-slate-400 ml-auto" />
              ) : (
                <ChevronDown className="h-5 w-5 text-slate-400 ml-auto" />
              )}
            </h3>
          </button>
          
          {expandedModule === 'coming' && (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {modulesWithoutDatasheets.map((module) => {
                const ModuleIcon = module.icon;
                
                return (
                  <Card key={module.id} className="bg-white/5 border-white/10 opacity-60">
                    <CardContent className="p-5">
                      <div className="flex items-start gap-4">
                        <div className={`w-12 h-12 rounded-xl ${module.color} flex items-center justify-center flex-shrink-0 opacity-50`}>
                          <ModuleIcon className="h-6 w-6 text-white" />
                        </div>
                        <div className="flex-1 min-w-0">
                          <h4 className="font-semibold text-white text-sm mb-1">
                            {module.name}
                          </h4>
                          <p className="text-xs text-slate-500 line-clamp-2 mb-3">
                            {module.description}
                          </p>
                          <div className="text-xs text-slate-500">
                            Datasheet coming soon
                          </div>
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                );
              })}
            </div>
          )}
        </div>

        {/* Contact Section */}
        <div className="mt-16 text-center">
          <Card className="bg-gradient-to-r from-blue-600/20 to-indigo-600/20 border-blue-500/30">
            <CardContent className="p-8">
              <h3 className="text-xl font-bold text-white mb-2">Need More Information?</h3>
              <p className="text-slate-300 mb-4">
                Contact ZKTeco UK for detailed consultations and custom solutions
              </p>
              <p className="text-2xl font-bold text-blue-400">0121 790 1600</p>
              <p className="text-slate-400 text-sm mt-2">sales@zkteco.co.uk</p>
            </CardContent>
          </Card>
        </div>

        {/* Footer */}
        <div className="mt-12 text-center text-slate-500 text-sm">
          <p>© {new Date().getFullYear()} ZKTeco UK. All rights reserved.</p>
          <p className="mt-1">
            <a href="/login" className="text-blue-400 hover:text-blue-300">Login</a>
            {' '} to access the full configuration tools
          </p>
        </div>
      </div>
    </div>
  );
};

export default PublicDatasheets;
